import styled from "styled-components";

const PartsListStyles = {
  // ============================================================================
  // 共通スタイル
  // ============================================================================

  // 部品情報タイトル
  PartsTitle: styled.h3`
    padding: 5px 0 0 5px;
    color: #333;
    font-size: 20px;
    line-height: 30px;
    margin: 30px 0 0;
    font-weight: bold;
    border-left: 5px solid #f33;
  `,

  // 部品確認テーブル
  PLTable: styled.table`
    margin-top: 10px;
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 10px;
    font-size: 14px;
    border: 1px solid #ccc;
    color: #333;

    tbody > tr > td {
      background: #fff;
      border: 1px solid #333;
      padding: 8px 2px;
      text-align: center;
    }
  `,

  // 部品名ヘッダー（現車紐付きの場合）
  PartsNameHeaderGensha: styled.th`
    background: #ffd700;
    color: #333;
    font-size: 16px;
    font-weight: bold;
    text-align: left;
    padding: 2px 5px;
    border: 1px solid #333;
  `,

  // 部品名ヘッダー（通常）
  PartsNameHeaderNormal: styled.th`
    background: #ff3333;
    color: #fff;
    font-size: 16px;
    font-weight: bold;
    text-align: left;
    padding: 2px 5px;
    border: 1px solid #333;
  `,

  // 部品カテゴリアイコン
  PartsCategoryIcon: styled.span`
    display: inline-block;
    padding: 2px 6px;
    margin: 2px;
    border-radius: 3px;
    font-size: 12px;
    font-weight: bold;
    color: #fff;
  `,

  // テーブルヘッダー
  ConfirmTableHeader: styled.th`
    background-color: #f5f5f5;
    border: 1px solid #ccc;
    padding: 8px;
    text-align: center;
    font-weight: bold;
    color: #333;
    vertical-align: middle;
  `,

  // 送料ヘッダー（税別、背景色#FFF666）
  DeliveryHeaderTaxEx: styled.th`
    background-color: #fff666;
    border: 1px solid #333;
    padding: 8px;
    text-align: center;
    font-weight: bold;
    color: #333;
    vertical-align: middle;
  `,

  // テーブルセル
  ConfirmTableCell: styled.td`
    border: 1px solid #ccc;
    padding: 8px;
    background-color: #fff;
    vertical-align: middle;
    text-align: center;
  `,

  // 在庫確認ラジオ（縦並び・ボタンと文字の縦中央揃え）
  ZaikoRadioWrap: styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;

    label {
      display: inline-flex;
      align-items: center;
      gap: 4px;
      margin: 0;
      line-height: 1.2;
      cursor: pointer;
    }

    input[type="radio"] {
      margin: 0;
      vertical-align: middle;
    }
  `,

  // 写真・ファイルアイコン
  FileIcon: styled.img`
    width: 20px;
    height: 20px;
    cursor: pointer;
    margin: 0 2px;
    vertical-align: middle;
  `,

  // 自社管理番号セル（背景色#FDF5E6）
  CompanyCodeCellBg: styled.td`
    border: 1px solid #ccc;
    padding: 8px;
    background-color: #fdf5e6 !important;
    text-align: center;
    vertical-align: middle;
  `,

  // 未回答行（noneクラス）
  NoneRow: styled.tr`
    background-color: #c0c0c0;

    td {
      background-color: #c0c0c0;
    }
  `,

  // 在庫なし回答行（nonegrクラス）
  NonegrRow: styled.tr`
    background-color: #d3d3d3;

    td {
      background-color: #d3d3d3;
    }
  `,

  // 質問ボタン
  QuestionButton: styled.a`
    vertical-align: middle;
    margin-top: -5px;
    margin-left: 8px;
    display: inline-block;
    background: #3366ff url(/images/arrow_important.png) no-repeat 10px 50%;
    color: #fff;
    height: 33px;
    border-style: solid;
    border-width: 1px;
    border-color: #99ccff #1c3dc0 #1c3dc0 #99ccff;
    border-radius: 5px;
    text-align: center;
    line-height: 33px;
    font-size: 18px;
    font-weight: bold;
    padding: 0 10px 0 30px;
    cursor: pointer;

    &:hover {
      background: #1c3dc0;
    }
  `,

  // 入庫済み車輌ボタン
  StockedVehicleButton: styled.a`
    display: inline-block;
    background: #ff3333;
    color: #fff;
    height: 28px;
    border: 1px solid #ac1d1f;
    border-radius: 3px;
    text-align: center;
    line-height: 28px;
    font-size: 14px;
    padding: 0 10px;
    cursor: pointer;
    text-decoration: none;
    margin: 2px;

    &:hover {
      background: #e52e2e;
    }
  `,

  // 損保依頼分の警告テキスト
  InsuranceWarning: styled.div`
    color: #ff0000;
    font-size: 12pt;
    font-weight: bold;
    margin: 10px 0;
  `,

  // ============================================================================
  // partsListArea専用スタイル
  // ============================================================================

  FlexRow: styled.div`
    display: flex;
    flex-direction: row;
    gap: 0;
  `,

  PLHeadTr1: styled.tr``,

  PLHeadTh1: styled.th`
    background: #ff3333;
    color: #fff;
    font-size: 16px;
    font-weight: bold;
    text-align: left;
    padding: 2px 5px;
    border: 1px solid #333;
    span.icon_r {
      background-color: #c00;
    }

    span {
      font-size: 11px;
      padding: 2px;
      display: inline-block;
      color: #fff;
      margin: 0 1px;
    }
    span.icon_rb {
      background-color: #060;
    }

    span.icon_g {
      background-color: #606;
    }

    span.icon_e {
      background-color: #00c;
    }

    span.icon_y {
      background-color: #ffaa00;
    }

    span.icon_n {
      background-color: #666666;
    }
  `,

  PLHeadTr2: styled.tr`
    background-color: #ff3333;
  `,

  PLHeadTh2: styled.th`
    background: #ffbcbc;
    font-weight: bold;
    border: 1px solid #333;
    padding: 8px 2px;
    text-align: center;
  `,

  GrayBtn: styled.a`
    display: inline-block;
    background: #ddd;
    color: #333;
    height: 28px;
    border-style: solid;
    border-width: 1px;
    border-color: #eee #999 #999 #eee;
    border-radius: 5px;
    text-align: center;
    line-height: 28px;
    font-size: 14px;
    padding: 0 10px;
    cursor: pointer;
    text-decoration: none;

    &:hover {
      background: #ccc;
    }
  `,

  RequiredMark: styled.img`
    display: inline-block;
    align-items: center;
  `,

  // 最終回答者表示コンテナ
  FinalAnswererContainer: styled.div`
    margin-top: 10px;
  `,

  // 最終回答者ラベル
  FinalAnswererLabel: styled.span`
    background-color: #ff3333;
    font-size: 16px;
    color: #ffffff;
    padding: 4px 12px;
  `,

  FlexBetween: styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 0;
  `,

  ToggleButton: styled.a`
    display: inline-block;
    background: #ddd;
    color: #333;
    height: 28px;
    border-style: solid;
    border-width: 1px;
    border-color: #eee #999 #999 #eee;
    border-radius: 5px;
    text-align: center;
    line-height: 28px;
    font-size: 14px;
    padding: 0 10px;
    cursor: pointer;

    &:hover {
      background: #ccc;
    }
  `,

  AddPartsSection: styled.div`
    margin: 20px 0;
  `,

  AddPartsArea: styled.div`
    display: block;
    padding: 5px;
    border: #f30 1px solid;
    margin-top: 15px;
  `,

  CategorySelectTable: styled.table`
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;
    border: 1px solid #ccc;
  `,

  CategorySelectHeader: styled.th`
    background: #ffbcbc;
    font-weight: bold;
    border: 1px solid #333;
    padding: 8px 2px;
  `,

  CategorySelectCell: styled.td`
    background: #fff;
    border: 1px solid #333;
    padding: 8px 2px;
  `,

  StepText: styled.span`
    font-weight: bold;
    color: #333;
  `,

  ArrowText: styled.span`
    font-weight: bold;
    color: #666;
    font-size: 16px;
  `,

  RegisterButton: styled.a`
    display: inline-block;
    background: #ddd;
    color: #333;
    height: 28px;
    border: 1px solid #999;
    border-radius: 3px;
    text-align: center;
    line-height: 28px;
    font-size: 14px;
    padding: 0 10px;
    cursor: pointer;
    text-decoration: none;

    &:hover {
      background: #ccc;
    }
  `,

  AddPartsTable: styled.table`
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 20px;
    font-size: 14px;
    border: 1px solid #ccc;
    tbody > tr > td {
      background: #fff;
      border: 1px solid #333;
      padding: 8px 2px;
      text-align: center;
    }
  `,

  AddPartsHeader: styled.th`
    background-color: #ffbcbc;
    border: 1px solid #ccc;
    padding: 8px;
    text-align: center;
    font-weight: bold;
    color: #333;
    vertical-align: middle;
    border: 1px solid #333;
  `,

  AddPartsNameHeader: styled.th`
    background: #ff3333;
    color: #fff;
    font-size: 16px;
    font-weight: bold;
    text-align: left;
    padding: 2px 5px;
    border: 1px solid #333;
  `,

  PartsConfirmTableHeader2Tr: styled.tr`
    background-color: #ff3333;
  `,

  PartsConfirmTableHeader2Th: styled.th`
    background: #ffbcbc;
    font-weight: bold;
    border: 1px solid #333;
    padding: 8px 2px;
    text-align: center;
  `,
};

export default PartsListStyles;
